import { container } from "tsyringe";
import { EsimProvider } from "./EsimProvider";
export const DependencyInjectionEsimInfrastructure = () => {
    container.registerSingleton("iEsimProvider", EsimProvider);
};
